
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import { MultiColumnsBlockListItemModel, MultiColumnsBlockSettingsModel } from 'fourwaves-shared';
import MultiColumnsBlockListItem from './MultiColumnsBlockListItem.vue';

@Component({
  components: {
    MultiColumnsBlockListItem,
  },
})
export default class MultiColumnsBlockList extends Vue {
  @Prop({ type: Array, required: true }) readonly items!: MultiColumnsBlockListItemModel[];
  @Prop({ type: Object, required: true }) readonly settings!: MultiColumnsBlockSettingsModel;

  get rootStyles(): Record<string, number | string> {
    return { '--max-row': this.settings.maxItemsInRow };
  }
}
